import { Image } from '@starsoft/common/components';
import styles from './styles.module.scss';
import { WalletService } from '@starsoft/common/services';
import { FundedAccountProps } from './props';
import { memo } from 'react';
import { getMoneyOrAmount } from '@/utils/account/getMoneyOrAmount';

function FundedAccount({ item }: FundedAccountProps) {
  return (
    <div key={item.id.toString()} className={styles.container}>
      <div className={styles.container__items}>
        <Image
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${item?.coin?.image}`}
          alt={`coin-image-${item?.coin?.name}`}
          className={styles.container__items__image}
        />
        <div className={styles['container__items__labels']}>
          <span className={styles['container__text--strong']}>
            {item.coin.code}
          </span>
          <span className={styles['container__text--common']}>
            {item.coin.name}
          </span>
        </div>
      </div>

      <div className={styles['container__money']}>
        <span className={styles['container__text--strong']}>
          {WalletService.maskCurrency({
            amount: getMoneyOrAmount(item.balance),
            coin: item.coin,
          })}
        </span>
        <span className={styles['container__text--common']}>
          {WalletService.maskCurrency({
            amount: Number(
              getMoneyOrAmount(item?.balance) *
                getMoneyOrAmount(item?.coin?.price),
            ),
            hideSymbol: false,
          })}
        </span>
      </div>
    </div>
  );
}

export default memo(FundedAccount);
